import animateSections from "./animationSections";
import { fetchPath } from '../../config/defPath'

declare global {
  interface Window {
    isSend: boolean
  }
}
window.dataLayer = window.dataLayer || [];

export async function submitRegistro(form: any) {
  const formData: any = new FormData(form)
  
  let tycLett = formData.get('tyc')
  let markLett = formData.get('marketing')
  /* let infoLett = formData.get('info') */
  let tyc = tycLett === 'on' ? 1 : 0
  let mark = markLett === 'on' ? 1 : 0
  /* let info = infoLett === 'on' ? 1 : 0 */
  formData.set('tyc', tyc)
  formData.set('marketing', mark)
  /* formData.set('info', info) */
  
  
  // fecha
  let day = formData.get('day')
  let month = formData.get('month')
  let year = formData.get('year')
  const dateBirthday = `${year}-${month}-${day}`
  formData.set('date_birthday', dateBirthday) // '2023-04-12'
  
  const temp = Object.fromEntries(formData)
  
  let url = `${fetchPath}/aguila/loyalty/form/register`
  
  try {
    let res = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(temp)
      //body:temp
    })
    const data = await res.json();
    validateRequestRegister(data, form, res.status)
  } catch (error) {
    console.log("error", error)
  }
}

// const error = document.createElement('div')

const validateRequestRegister = (data: any, form: HTMLElement, res: any) => {
  const parent = document.querySelector('.ar__content') as HTMLElement
  const btnClose = document.querySelector('.close__modal') as HTMLElement
  // const selectGender = form.querySelector('#gender') as HTMLSelectElement

  if (res == 201) {
    // const selectValue = selectGender.value == 'femenino' ? 'Mujer' : 'Hombre'
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Register',
      'event_action': 'Success',
      'event_label': 'Register Success',
    });
    parent.classList.add('yellow')
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Content',
      'event_label': 'Thank You Page Register',
      'interaction': 'true',
      'component_name': 'Thank You Page',
      'element_text': 'Visualización Thank You',
    });

    const storedItems = JSON.parse(sessionStorage.getItem('TUP'));

    if (window.location.search.match(/(\?|&)redirect\=([^&]*)/)) {
      var parameterValue = decodeURIComponent(window.location.search.match(/(\?|&)redirect\=(.*)/)[2]);
      location.href = parameterValue
    }
    else {
      // location.href = '/estadio-aguila/registro/gracias'
      location.href = storedItems.typ2.urlredirect
    }
    
    //animateSections('#sectionRegister', '#thankyouPage')

    btnClose && btnClose.classList.add('hide')

    // let gender = sessionStorage.getItem('tempGender') ? sessionStorage.getItem('tempGender') : selectValue
    let gender = sessionStorage.getItem('tempGender') ? sessionStorage.getItem('tempGender') : "Hombre"

    if (gender) sendAvatarInitial(gender)
  }

  else {
    const error = document.getElementById('error-drupal')
    if (!error) return
    error.classList?.add('error-drupal')
    error.innerHTML = data?.message
    
    setTimeout(() => {
      error.classList?.remove('error-drupal')
      error.innerHTML = ""
    }, 3000);
  }
}

export async function sendAvatarInitial(genero: string) {
  let url = `${fetchPath}/aguila/loyalty/save/avatar`

  try {
    let info = {
      json: { "genero": `${genero}`, "piel": "B", "cabello": { "type": "03", "color": "000000" }, "barba": { "type": "02", "color": "000000" }, "Sup": { "type": "camiseta", "code": "01" }, "Inf": { "type": "pant-corta", "code": "01" }, "medias": { "code": "01" }, "Cal": { "type": "guayos", "code": "01" }, "Acc": [{ "type": "guantes", "code": "01" }, { "type": "gafas-01" }] }
    }
    let res = await fetch(url, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(info)
    })
  }

  catch (error) {
    console.log("error", error)
  }
}

export async function submitLogin(form: any) {
  const formData: any = new FormData(form)
  const temp = Object.fromEntries(formData)

  let url = `${fetchPath}/aguila/loyalty/form/login`

  try {
    let res = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(temp)
      //body:temp
    })
    const data = await res.json();
    validateRequestLogin(data, form, res.status)
  }

  catch (error) {
    console.log("error", error)
  }
}

const validateRequestLogin = async(data: any, form: HTMLElement, res: any) => {
  const sectionLogin = document.querySelector('#sectionLogin') as HTMLElement

  if (res === 200) {

    const res = await fetch(`${fetchPath}/aguila/loyalty/validate/session`, { method: 'POST' });
    const data = await res.json();

    let updateData = {
      ...data.response,
      json_avatar: JSON.parse(data.response.json_avatar.replace(/(\r\n|\n|\r)/gm, "")),
      list_articles: data.response.list_articles ? [...data.response.list_articles] : [],
      total_questions: data.response.total_questions,
      collectables: data.response.collectables
    }

    let userData = {
      state : {
        logged: true,
        user: updateData,
        coins: parseInt(data.response.coins),
        points: parseInt(data.response.points),
        listArticles: data.response.list_articles,
      }
    }

    sessionStorage.setItem('user-estadio',  JSON.stringify(userData))
    
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Login',
      'event_action': 'Success',
      'event_label': 'Login Success',
    });
    /* sectionLogin.classList.add('ar__close') */

    const storedItems = JSON.parse(sessionStorage.getItem('TUP'));

    if (window.location.search.match(/(\?|&)redirect\=([^&]*)/)) {
      var parameterValue = decodeURIComponent(window.location.search.match(/(\?|&)redirect\=(.*)/)[2]);
      window.location.href = parameterValue
    }
    else {
      location.href = '/copa-america/predicciones'
      // window.location.href = document.referrer
      return
    }
  }

  if (res === 409 || res === 400) {
    if (data.message.includes('contraseña')) {
      let passwordInput = document.querySelector("#login .row input[type='password']")
      let isError = document.querySelector("#login .row #bouncer-error_password")
      !isError && passwordInput.classList.add('error')
      !isError && passwordInput?.insertAdjacentHTML("afterend", `<div class='error-message' id='bouncer-error_password'>${data.message}</div>`)
    } else {
      let emailInput = document.querySelector("#login .row input[type='email']")
      let isError = document.querySelector("#login .row #bouncer-error_email")
      !isError && emailInput?.classList.add('error')
      !isError && emailInput?.insertAdjacentHTML("afterend", `<div class='error-message' id='bouncer-error_email'>${data.message}</div>`)
    }
  }
}
// @ts-ignore
window.isSend = false

export async function submitRetrieve(form: any) {

  if (window.isSend) return

  const formData: any = new FormData(form)
  const temp = Object.fromEntries(formData)

  let url = `${fetchPath}/aguila/loyalty/recoverd/password`

  try {
    window.isSend = true
    let res = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(temp)
      //body:temp
    })
    const data = await res.json();

    return { data, statusCode: res.status }
  }

  catch (error) {
    console.log("error", error)
  }
}

export const initTime = () => {
  window.isSend = false

  const time = document.querySelector('#time') as HTMLElement
  const reenviar = document.querySelector('#reenviar')?.parentNode as HTMLElement
  const btnBack = document.querySelector('#backSesion') as HTMLAnchorElement
  btnBack && btnBack.classList.add('hidden')

  let countDownDate = new Date().getTime() + 17000;

  time.classList.remove('disabled')
  reenviar.classList.add('disabled')

  let x = setInterval(function () {
    let now = new Date().getTime();
    let distance = countDownDate - now;
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    time.innerHTML = `${minutes <= 9 ? `0${minutes}` : minutes}:${seconds <= 9 ? `0${seconds}` : seconds}`;

    if (distance < 0) {
      clearInterval(x);
      time.innerHTML = "00:00";
      time.classList.add('disabled')
      reenviar.classList.remove('disabled')
      btnBack.classList.remove('hidden')
    } else {
      btnBack.classList.add('hidden')

    }
  }, 1000);
}


export async function sendLoginV2(form: { mail: string, phone: string }) {
  try {
    const url = `${fetchPath}/aguila/loyalty/form/newlogin`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(form),
    })

    return response.json();
  } catch (err) {
    throw err;
  }
}

export async function sendRegisterV2(form: { [key: string]: string | number }) {
  try {
    const url = `${fetchPath}/aguila/loyalty/form/newRegister`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(form),
    })

    return response.json();
  } catch (err) {
    throw err;
  }
}

export async function checkEmailLoginV2(mail: string) {
  try {
    const url = `${fetchPath}/aguila/loyalty/form/validate-mail`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mail }),
    })

    const json_response = await response.json();
    if (json_response.message === 'EMAIL_ALREADY_REGISTERED') throw { field: 'mail', message: 'El email ya se encuentra registrado' }

    return json_response;
  } catch (err) {
    throw err;
  }
}

export async function checkPhoneLoginV2(phone: string) {
  try {
    const url = `${fetchPath}/aguila/loyalty/form/validate-phone`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phone }),
    })

    const json_response = await response.json();
    if (json_response.message === 'PHONE_ALREADY_REGISTERED') throw { field: 'phone', message: 'El teléfono ya se encuentra registrado' }

    return json_response;
  } catch (err) {
    throw err;
  }
}

export async function validateSessionV2() {
  try {
    const url = `${fetchPath}/aguila/loyalty/validate/session`;

    const response = await fetch(url, {
      method: 'POST',
    })
    const json_response = await response.json();

    let updateData = {
      ...json_response.response,
      json_avatar: JSON.parse(json_response.response.json_avatar.replace(/(\r\n|\n|\r)/gm, "")),
      list_articles: json_response.response.list_articles ? [...json_response.response.list_articles] : [],
      total_questions: json_response.response.total_questions,
      collectables: json_response.response.collectables
    }

    let userData = {
      state: {
        logged: true,
        user: updateData,
        coins: parseInt(json_response.response.coins),
        points: parseInt(json_response.response.points),
        listArticles: json_response.response.list_articles,
      }
    }

    sessionStorage.setItem('user-estadio', JSON.stringify(userData));

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Login',
      'event_action': 'Success',
      'event_label': 'Login Success',
    });

    return response.ok;
  } catch (err) {
    throw err;
  }
}

export async function resetUserV2(reset: string | number) {
  try {
    const url = `${fetchPath}/aguila/loyalty/reset/validate`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ reset }),
    })

    const json_response = await response.json();
    switch (json_response.message) {
      case 'UNAUTHORIZED':
        throw { message: 'Usuario no logueado o no registrado en el estadio aguila' }

      case 'NO_DATA':
        throw { message: 'El cuerpo de la solicitud no corresponde con lo requerido' }

      case 'ERROR_DATA':
        throw { message: 'Ha ocurrido un error' }

      case 'UNREGISTERED_PHONE':
        throw { message: 'El teléfono ingresado no se encuentra registrado' }

      case 'UNREGISTERED_EMAIL':
        throw { message: 'El correo ingresado no se encuentra registrado' }
    }
    return json_response;
  } catch (err) {
    throw err;
  }
}

export async function sendCodeV2(payload: { reset: string | number, code: string | number }) {
  try {
    const url = `${fetchPath}/aguila/loyalty/reset/token`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    const json_response = await response.json();
    switch (json_response.message) {
      case 'UNAUTHORIZED':
        throw { message: 'Usuario no logueado o no registrado en el estadio aguila' }

      case 'NO_DATA':
        throw { message: 'El cuerpo de la solicitud no corresponde con lo requerido' }

      case 'ERROR_CODE':
        throw { message: 'El código ingresado no existe o no cumple con la estructura' }

      case 'TIME_LIMIT':
        throw { message: 'El codigo ha caducado' }
    }
    return json_response;
  } catch (err) {
    throw err;
  }
}

export async function updateDataV2(payload: { reset: string, token: string, str: string }) {
  try {
    const url = `${fetchPath}/aguila/loyalty/reset/update`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    const json_response = await response.json();
    switch (json_response.message) {
      case 'UNAUTHORIZED':
        throw { message: 'Usuario no logueado o no registrado en el estadio aguila' }

      case 'NO_DATA':
        throw { message: 'El cuerpo de la solicitud no corresponde con lo requerido' }

      case 'ERROR_DATA':
        throw { message: 'Ha ocurrido un error' }
        
      case 'SAME_VALUE':
        throw { message: json_response.data }

      case 'EMAIL_ALREADY_REGISTERED':
        throw { message: 'El nuevo correo para actualizar ya se encuentra registrado' }

      case 'PHONE_ALREADY_REGISTERED':
        throw { message: 'El nuevo telefono para actualizar ya se encuentra registrado' }
    }
    return json_response;
  } catch (err) {
    throw err;
  }
}

export async function resendCodeV2(payload: { reset: string, value: string }) {
  try {
    const url = `${fetchPath}/aguila/loyalty/reset/resend`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    const json_response = await response.json();
    switch (json_response.message) {
      case 'UNAUTHORIZED':
        throw { message: 'Usuario no logueado o no registrado en el estadio aguila' }

      case 'NO_DATA':
        throw { message: 'El cuerpo de la solicitud no corresponde con lo requerido' }

      case 'ERROR_DATA':
        throw { message: 'Ha ocurrido un error' }

      case 'UNREGISTERED_PHONE':
        throw { message: 'El teléfono ingresado no se encuentra registrado' }

      case 'UNREGISTERED_EMAIL':
        throw { message: 'El correo ingresado no se encuentra registrado' }
    }
    return json_response;

  } catch (err) {
    throw err;
  }
}